import React, { useState } from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import { ClickableLink } from './WorkExperienceGrid.style';
import { workExperienceActions } from 'store/redux-store/candidate-work-experience/slice';
import { useDispatch } from 'react-redux';
import { WorkExperienceView } from '../viewComponents/WorkExperienceView';
import { useParams } from 'react-router-dom';

const FacilityGridCell = React.memo(function FacilityGridCell(params: any) {
  const dispatch = useDispatch();
  const urlParams = useParams<{
    travelerId: string;
    brandId: string;
  }>();

  const [showWorkExperienceView, setShowWorkExperienceView] = useState<boolean>(false);

  const openViewComponent = () => {
    dispatch(workExperienceActions.setSelectedWorkExperience(params.row));
    if (params?.row?.workHistoryId && urlParams?.travelerId) {
      dispatch(
        workExperienceActions.getReferenceByWorkExperienceAction({
          candidateId: parseInt(urlParams?.travelerId),
          workHistoryId: parseInt(params?.row?.workHistoryId),
        }),
      );
    }
    setShowWorkExperienceView(true);
  };

  const handleClick = () => {
    openViewComponent();
  };
  const handleClose = () => {
    setShowWorkExperienceView(false);
  };

  return (
    <>
      <ClickableLink onClick={handleClick}>{params.value}</ClickableLink>

      {showWorkExperienceView && <WorkExperienceView opened={true} handleClosed={() => handleClose()} />}
    </>
  );
});

export const GridCellEditFacility = (params: GridCellParams) => {
  return <FacilityGridCell {...params} />;
};
